
import React, { useEffect, useState } from "react";
import "../Leagues.css";
import DataTableComponent from "../../../../../Util/DataTable/DataTable";
import Popup from "reactjs-popup";
import SeasonPopup from "../SeasonPopup/Season";
import { BACK_DROP_FALSE, loadColumns } from "../../../../../Util/helper";
import add from "../../../../../assets/add-icon.svg";
import "./IndvRegistrations.css";
import axiosApi from "../../../../../core/interceptor/interceptor";
import { config, PERMISSIONS } from "../../../../../config";
import AddTeamLeague from "./Modals/AddTeamLeague";
import { permissions } from "../../../../../Store/reducers/PermissionsReducer";
import { useSelector } from "react-redux";
import { AsyncPaginate } from 'react-select-async-paginate';
import Tab from "../../../../../Util/Tabs/Tab";
import WarningDialogue from "../../../../../Util/WarningDialogue";
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const conditionalRowStyles = [
	{
		when: row => !!row.toggleSelected,
		style: {
			backgroundColor: "#82eead",
		}
	}
];


export default function IndvRegistrations() {
	const permission = useSelector(permissions);
	const [season, setSeason] = useState(null);
	const [teams, setTeams] = useState([]);
	const [total, setTotal] = useState(0);
	const [filter, setFilter] = useState({
		limit: 50,
		page: 1,
		sort_column: 'created_at',
		direction: 'desc',
	});
	const [loader, setLoader] = useState(true);
	const [selectedSeason, setSelectedSeason] = useState(null);
	// eslint-disable-next-line
	const [seasonFilter, setSeasonFilter] = useState({ page: 1, search: '' });
	// eslint-disable-next-line
	const [leagueFilter, setLeagueFilter] = useState({ page: 1, search: '' });
	const [selectedLeagues, setSelectedLeague] = useState(null);
	const [selectedIndvIds, setSelectedIndvIds] = useState([]);
	const [allSelectedLeagues, setAllSelectedLeagues] = useState([]);
	const [selectedTab, setSelectedTab] = useState('');
	const [assignTeam, setAssignTeam] = useState(false);
	const customStyles = {
		menu: (provided, state) => ({
			...provided,
			fontSize: "13px",
			lineHeight: "16px",
			wordBreak: "break-word",
		}),
		option: (provided, state) => ({
			...provided,
			cursor: "pointer"
		})
	}
	const [openWarningPopup, setOpenWarningPopup] = useState(false);
	const [popUpContent, setPopUpContent] = useState({});
	
	useEffect(() => {
		setColumns((prev) => {
			const prev_ = [...prev];
			if (!selectedSeason) {
				if (prev_[0].type === 'select-individual') {
					prev_.splice(0, 1);
				}
				return prev_;
			}
			if (!selectedTab) {
				if (prev_[0].type !== 'select-individual')
					prev_.unshift({
						name: 'Select',
						type: 'select-individual',
						selector: 'selected',
						actionHandler: (id, checked, player) => {
							setSelectedIndvIds((prev) => {
								const prev__ = [...prev];
								const idx = prev__.indexOf(id);
								if (idx >= 0) {
									if (!checked) {
										prev__.splice(idx, 1);
									}
								} else {
									prev__.push(id);
								}
								return prev__;
							});
							player.selected = checked;
							if (player && player.league) {
								setAllSelectedLeagues((prev) => {
									const prev__ = [...prev];
									if (checked) {
										prev__.push(player.league);
									} else {
										const idx = prev__.findIndex(x => x.id === player.league.id);
										if (idx >= 0) {
											prev__.splice(idx, 1);
										}
									}
									
									return prev__;
								});
							}

						},
					});
				else 
					prev_[0] = {
						name: 'Select',
						type: 'select-individual',
						selector: 'selected',
						leagueSelected: selectedLeagues,
						actionHandler: (id, checked, player) => {
							setSelectedIndvIds((prev) => {
								const prev__ = [...prev];
								const idx = prev__.indexOf(id);
								if (idx >= 0) {
									prev__.splice(idx, 1);
								} else {
									prev__.push(id);
								}
								return prev__;
							});
							player.selected = checked;
							if (player) {
								setAllSelectedLeagues((prev) => {
									const prev__ = [...prev];
									if (checked) {
										prev__.push(player.league);
									} else {
										const idx = prev__.findIndex(x => x.id === player.league.id);
										if (idx >= 0) {
											prev__.splice(idx, 1);
										}
									}
									
									return prev__;
								});
							}

						},
					};
			}
			return prev_
		});
	}, [selectedSeason, selectedTab, selectedLeagues]);

	useEffect(() => {
		getTeams(0);
		// eslint-disable-next-line
	}, [
		filter.sort_column,
		filter.page,
		filter.direction,
		filter.limit,
		selectedTab,
		selectedSeason,
		selectedLeagues
	]);

	const [columns, setColumns] = useState([
		{
			name: 'Name',
			selector: 'user.full_name'
		},
		{
			name: 'Gender',
			selector: 'user.gender',
		},
		{
			name: 'Email',
			selector: 'user.email',
		},
		{
			name: 'Phone',
			selector: 'user.cell_phone',
		},
		{
			name: 'Season',
			selector: 'league.season.name',
			type: 'individual_reg_old'
		},
		{
			name: 'League',
			selector: 'league.name'
		},
		{
			name: 'Sport',
			selector: 'league.sport.title',
		},
		{
			name: 'Notes',
			selector: 'notes'
		},
		{
			name: 'Level',
			selector: 'league.play_level',
		},
		{
			name: 'Transaction Id',
			selector: 'transaction_id',
			type: Array.isArray(permission) && permission.includes(PERMISSIONS.REFUND_FORFEIT) ? 'clickable_transaction_id' : 'nonClickable_transaction_id',
		},
		{
			name: 'Status',
			selector: 'payment_status',
			type: 'payment-status-individual',
		  },
		  {
			name: 'Paid by',
			selector: 'paid_by',
			type: 'paid_by_type',
		  },
		{
			name: 'Day(s) played',
			selector: 'league.days_played',
			type: 'list',
			renderer: (data) => {
				return <>
					{Array.isArray(data) ? data.map((item, idx) => item.day + (idx < data.length - 1 ? ', ' : '')) : ''}
				</>
			}
		},
		{
			name: 'Date',
			type: 'date',
			selector: 'created_at'
		},
	]);
	useEffect(() => {
		getTeams();
		//eslint-disable-next-line
	}, []);

	useEffect(() => {
		setColumns((prev) => {
			const temp = [...prev];
			if (prev[prev.length -1 ].type === 'ind-action') {
				temp.splice(prev.length -1 , 1);
			} else if (!selectedTab) {
				temp.push({
					name: 'Action',
					type: 'ind-action',
					selector: 'ind-action',
					renderer: (data) => {
						return <>
							<button className={`refund-forfeit-button ${data.transaction_id ? 'h-40' : ''}`} type="button" onClick={() => cancelIndividual(data.id)}>Cancel { data.transaction_id ? ' & Refund': ''}</button>
						</>
					}
				});
			}
			return temp;
		})
		
	}, [selectedTab])

	const [open, setOpen] = useState(false);
	const [openAddTeam, setAddTeam] = useState(false);
	const closeModal = (data) => {
		if (data) {
			setSeason(data);
			getTeams(data.id);
		}
		setOpen(false);
	}

	function getTeams(id = null, filter_ = null) {
		id = selectedLeagues?.id ? selectedLeagues.id : 0
		setLoader(true);
		axiosApi.get(`${config.apiUrl}/teams/individualList/league/0`,
			{
				params: {
					...(filter_ ? filter_ : filter),
					status: selectedTab.split('/').pop() || 'active',
					season_id: (selectedSeason && selectedSeason.id ? selectedSeason.id : 0),
				}
			}).then((resp) => {
				if (resp && resp.data && resp.data.data) {
					resp.data.data.forEach(element => {
						if (selectedIndvIds && selectedIndvIds.length && selectedIndvIds.includes(element.id)) {
							element.selected = true;
						} else {
							element.selected = false;
						}
					});
					setTeams(resp.data.data);
					setTotal(resp.data.total);
					setLoader(false);
				}
			}).catch((err) => {
				console.error(err);
				setLoader(false);
			});
	}

	const handleConditionalStyle = (row) => {
		const updateLeagues = teams.map(league => {
			if (row.id !== league.id) {
				return league;
			}
			return {
				...league,
				toggleSelected: !league.toggleSelected,
			};
		});
		setTeams(updateLeagues);
	}

	const handleChangeTable = (e) => {
		if (e.type === 'sort') {
			setFilter(prev => {
				getTeams((season && season.id) ? season.id : 0, {
					...prev,
					[e.target.name]: e.target.value,
					direction: e.target.direction,
				});
				return {
					...prev,
					[e.target.name]: e.target.value,
					direction: e.target.direction,
				};
			});
		} else {
			setFilter(prev => {
				getTeams((season && season.id) ? season.id : 0, {
					...prev,
					[e.target.name]: e.target.value,
				})
				return {
					...prev,
					[e.target.name]: e.target.value,
				};
			})

		}
	}

	const getAllSeasons = async (page_, searchString) => {
		const seasons = await axiosApi.get(`${config.apiUrl}/seasons`, { params: { page: page_, search: searchString } });
		return seasons.data.data;
	}

	const getLeagues = async (page_, searchString) => {
		const seasons = await axiosApi.get(`${config.apiUrl}/misc/leagues/${selectedSeason?.id || 0}`, { params: { page: page_, search_string: searchString, skipComplete: true } });
		return seasons.data.data;
	}

	const loadOptionsSeason = async (searchQuery, loadedOptions, { page }) => {
		setSeasonFilter((prev) => {
			if (prev.search !== searchQuery) {
				return { search: searchQuery, page };
			}
			return { search: searchQuery, page: page + 1 };
		});
		const seasons = await getAllSeasons(page, searchQuery);
		return {
			options: seasons,
			hasMore: seasons.length === 20,
			additional: {
				page: page + 1,
			},
		};
	};

	const loadOptionsLeague = async (searchQuery, loadedOptions, { page }) => {
		setLeagueFilter((prev) => {
			if (prev.search !== searchQuery) {
				return { search: searchQuery, page };
			}
			return { search: searchQuery, page: page + 1 };
		});
		const leagues = await getLeagues(page, searchQuery);
		return {
			options: leagues,
			hasMore: leagues.length === 20,
			additional: {
				page: page + 1,
			},
		};
	};

	const cancelIndividual = (id) => {
		setOpenWarningPopup(true);
		setPopUpContent({
			header: 'Confirm',
			description: 'Are sure you want to cancel individual player request?',
			icon: faExclamationTriangle,
			action: () => {
				axiosApi.post(`${config.apiUrl}/teams/individualList/cancel`, { id }).then((res) => {
					console.log('sss')
					setTeams((prev) => {
						const temp = [...prev];
						const index = temp.findIndex(x => x.id === id);
						console.log(temp.length);
						if (index !== -1) {
							temp.splice(index, 1);
						}
						console.log(temp.length);
						return temp;
					});
					setOpenWarningPopup(false);
				}).catch();
			}
		  });
	}

	return <>
		<div className="content-wrapper leagues-wrapper indv-wrapper">
			<div className="heading-wrapper">
				<div className="left">
					<h2 className="heading"> Individual Registration
						{/* - {season && season.name ? season.name : 'All Season'} */}
					</h2>
					{/* <span onClick={() => setOpen(o => !o)}>Change Season</span> */}
				</div>
				<div className="right">
					{
						!selectedTab &&
						selectedIndvIds.length > 0 &&
						Array.isArray(permission) &&
						permission.includes(PERMISSIONS.TEAM_MODIFICATIONS) && <>
							<button style={{ marginRight: 5 }} onClick={() => {
								setAddTeam(o => !o);
								setAssignTeam(true);
							}}><img src={add} alt='add-icon' />Assign Team</button>
							<button onClick={() => {
								setAddTeam(o => !o);
								setAssignTeam(false);
							}}><img src={add} alt='add-icon' />Create Team</button>
						</>
					}
				</div>
				{/* <Popup open={open} closeOnDocumentClick={BACK_DROP_FALSE} onClose={closeModal}>
						<SeasonPopup closeModal={closeModal} />
					</Popup>
					 */}
				<Popup open={openAddTeam} className="ind-team-popup" closeOnDocumentClick={BACK_DROP_FALSE} onClose={closeModal}>
					<AddTeamLeague
						closeModal={() => setAddTeam(false)}
						menuPortalTarget={document.body}
						indvRegIds={selectedIndvIds}
						leagueId={selectedLeagues && selectedLeagues.id}
						leagues={allSelectedLeagues}
						reloadPage={() => {
							setSelectedIndvIds([]);
							setAllSelectedLeagues([]);
							getTeams(selectedLeagues && selectedLeagues.id ? selectedLeagues.id : 0);
						}}
						assignTeam={assignTeam}
					/>
				</Popup>
			</div>
			<Tab tabs={[
				{
					name: "Active",
					url: ""
				},
				{
					name: "Processed",
					url: "/processed"
				},
				{
					name: "Cancelled",
					url: "/cancelled"
				},
			]} emit={(e) => {
				setFilter((prev) => {
					const filter_ = {
						limit: 50,
						page: 1,
						sort_column: 'created_at',
						direction: 'desc',
					};
					setSelectedTab((prevTab) => {
						if (prevTab !== e) {
							setTeams([]);
							setLeagueFilter({ page: 1, search: '' });
							setSeasonFilter({ page: 1, search: '' });
							setSelectedLeague(null);
							setSelectedSeason(null);
						}
						return e;
					});
					return filter_;
				});
			}}
			/>
			<div className="table-wrapper">
				<div className="search-blk league-search ind-reg-resp">
					<h2>Individual Registration Filters</h2>
					<div className="input-blk">
						<div className="drop-wrapper cs-resp">
							<div className="drop-down">
								<label>Season</label>
								<AsyncPaginate
									isClearable={true}
									classNamePrefix="cs-new-dropdown"
									value={selectedSeason}
									loadOptions={loadOptionsSeason}
									getOptionValue={(option) => option.id}
									getOptionLabel={(option) => option.name}
									onChange={(option) => {
										setSelectedSeason(option);
										setSelectedIndvIds([]);
										setAllSelectedLeagues([]);
									}}
									placeholder="Select Season"
									additional={{
										page: 1,
									}}
									debounceTimeout={1000}
									styles={customStyles}
									noOptionsMessage={() => "No Seasons Found."}
									className="multivalue-dropdown"
								// closeMenuOnSelect={false}
								/>
							</div>
							<div className="drop-down">
								<label>League</label>
								<AsyncPaginate
									key={selectedSeason?.id}
									classNamePrefix="cs-new-dropdown"
									isClearable={true}
									value={selectedLeagues}
									loadOptions={loadOptionsLeague}
									getOptionValue={(option) => option.id}
									getOptionLabel={(option) => option.name}
									onChange={(option) => {
										setSelectedLeague(option);
										setAllSelectedLeagues([]);
										setSelectedIndvIds([]);
									}}
									placeholder="Select League"
									additional={{
										page: 1,
									}}
									debounceTimeout={1000}
									styles={customStyles}
									noOptionsMessage={() => "No Leagues Found."}
									className="multivalue-dropdown"
								// closeMenuOnSelect={false}
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="heading-blk">
					<div className="left">
						<h2>Results</h2>
						<p>All Transactions of Mulberry and Cleveland.</p>
					</div>
					{
						selectedIndvIds.length > 0 &&  
						<div className="left">
							<strong>Total Selected Records: </strong> {selectedIndvIds && selectedIndvIds.length}
						</div>
					}
					
				</div>
				<div className="dataTable">
					<DataTableComponent key="table-admin-users"
						disableRowClicked={true}
						loading={loader}
						type={'season_league_team_info'}
						data={teams}
						columns={loadColumns({ columns })}
						handleConditionalStyle={handleConditionalStyle}
						onFilterChange={handleChangeTable}
						conditionalRowStyles={conditionalRowStyles}
						totalPage={total} />
				</div>
			</div>
			<WarningDialogue
				isOpen={openWarningPopup}
				header={popUpContent.header}
				description={popUpContent.description}
				icon={popUpContent.icon}
				action={popUpContent.action}
				onClose={() => setOpenWarningPopup(false)}
			/>
		</div>
	</>
}
